import { render, staticRenderFns } from "./ActivityTypeWidget.vue?vue&type=template&id=13b73c42&scoped=true"
import script from "./ActivityTypeWidget.vue?vue&type=script&lang=js"
export * from "./ActivityTypeWidget.vue?vue&type=script&lang=js"
import style0 from "./ActivityTypeWidget.vue?vue&type=style&index=0&id=13b73c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b73c42",
  null
  
)

export default component.exports